import React from 'react';
import './Modal.css'; // Asegúrate de crear y ajustar este archivo CSS según tus necesidades

const Modal = ({ show, handleClose, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button className="modal-button" onClick={handleClose}>X</button>
      </section>
    </div>
  );
};

export default Modal;
